import React from 'react';
import PropTypes from 'prop-types';
import withContent from '../../containers/withContent';
import pageContent, { contentPropTypes } from './Notifications.content';

const GenericErrors = ({ errorType, content }) => {
	switch (errorType) {
		case 'genericServiceError':
			return <p>{content.serviceErrorDuringPaymentUploadDescription}</p>;
		case 'permissionError':
			return <p>{content.permissionErrorDescription}</p>;
		case 'sourceAccountLimitError':
			return <p>{content.sourceAccountLimitErrorDescription}</p>;
		default:
			return null;
	}
};

GenericErrors.propTypes = {
	errorType: PropTypes.string,
	content: PropTypes.shape(contentPropTypes),
};

export const EnhancedGenericErrors = withContent({ content: pageContent })(GenericErrors);
